import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=1051ba2e&scoped=true&"
import script from "./AppView.vue?vue&type=script&lang=ts&"
export * from "./AppView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1051ba2e",
  null
  
)

export default component.exports